import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import React from 'react';
import RewardsImg from '../../assets/epicRewards.png';
import content_Bg from '../../assets/ContentBG.webp';

interface EpicRewardsProps {
  isMobile?: Boolean | null;
}

const EpicRewards: React.FC<EpicRewardsProps> = ({ isMobile }) => {
  const renderImage = () => (
    <Grid size={{ xs: 12, md: 4 }}>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginLeft: { xs: 0, md: 20 } }}>
        <img
          src={RewardsImg}
          alt="learning"
          style={{
            width: isMobile ? '400px' : 570,
            height: isMobile ? '266px' : 'auto'
          }}
        />
      </Box>
    </Grid>
  );

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}
      mt={isMobile ? '60px' : 0}>
      <Grid container justifyContent="center" alignItems="center">
        {!isMobile && renderImage()}
        <Grid
          container
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',

                fontSize: '48px',
                lineHeight: '1'
              }}>
              <span style={{ color: 'white' }}>{`“ `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Epic Rewards Await -`}
              </span>
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`Unleash Your`}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Potential! `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              Every creation, every effort gets recognized! Valuables, badges, {'\n'}
              club entries, coins, and collectible cards—every step forward
              {'\n'}
              brings surprises. The harder you grit, the sweeter the rewards! {'\n'}
              Stay consistent, keep pushing, and watch the rewards grow {'\n'}
              beyond expectations!
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`  Epic Rewards Await -`}
            </span>
          </Typography>

          <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            Unleash Your
          </Typography>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {` Potential! `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            Every creation, every effort gets recognized! Valuables, badges, {'\n'}
            club entries, coins, and collectible cards—every step forward{'\n'}
            brings surprises. The harder you grit, the sweeter the rewards! {'\n'}
            Stay consistent, keep pushing, and watch the rewards grow {'\n'}
            beyond expectations!
          </Typography>
        </Grid>
        {isMobile && renderImage()}
      </Grid>
    </Box>
  );
};

export default EpicRewards;
